import { render, staticRenderFns } from "./PORTFOLIOFAVORITE.vue?vue&type=template&id=3ca78f7a"
import script from "./PORTFOLIOFAVORITE.vue?vue&type=script&lang=js"
export * from "./PORTFOLIOFAVORITE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports